import { useCallback, useEffect, useId, useLayoutEffect, useRef } from "react";

import { useBoundingRectStore } from "../stores/boundingRectStore";

export const useBoundingElement = () => {
  const id = useId();
  const elementRef = useRef<HTMLDivElement>(null);
  const { addBoundingRect, removeBoundingRect } = useBoundingRectStore();

  const addRect = useCallback(() => {
    if (elementRef.current) {
      addBoundingRect(id, elementRef.current.getBoundingClientRect());
    }
  }, [addBoundingRect, id]);

  useLayoutEffect(() => {
    const element = elementRef.current;
    if (element) {
      addRect();
      element.addEventListener("transitionend", addRect);
    }
    return () => {
      removeBoundingRect(id);
      if (element) {
        element.removeEventListener("transitionend", addRect);
      }
    };
  }, [id, removeBoundingRect, addRect]);

  useEffect(() => {
    window.addEventListener("resize", addRect);
    return () => window.removeEventListener("resize", addRect);
  }, [addRect]);

  return elementRef;
};
